import { isMatch, parse } from "date-fns";
import { DATE_STRING_FORMAT } from "../Constants/stringFormats";
import { zipCodeRequiresPlus4 } from "./zipCodesRequiringPlus4";

const validateLineServiceDate = (lineServiceDate, claimFromDate, claimToDate) => {
    if (!lineServiceDate || !isMatch(lineServiceDate, DATE_STRING_FORMAT) ||
        !isMatch(claimFromDate, DATE_STRING_FORMAT) || !isMatch(claimToDate, DATE_STRING_FORMAT)) return { valid: true };

    const parsedDate = parse(lineServiceDate, DATE_STRING_FORMAT, new Date());
    const parsedDateMilliseconds = parsedDate.getTime();

    const parsedFromDate = parse(claimFromDate, DATE_STRING_FORMAT, new Date());
    const parsedToDate = parse(claimToDate, DATE_STRING_FORMAT, new Date());

    if (parsedDateMilliseconds < parsedFromDate.getTime() || parsedDateMilliseconds > parsedToDate.getTime()) {
        return { valid: false, message: `Date is not between ${claimFromDate} and ${claimToDate}`, level: 'warning' }
    }

    return { valid: true };
};

const validateBilled = (billedAmount) => {
    if (isNaN(billedAmount)) return { valid: false, message: 'Value is expected to be a number', level: 'warning' };

    return { valid: true };
};

const validateZipCode = (zipCode, year, messageText = 'Nine digit zip code is required for accurate pricing in this location.') => {
    if (!zipCode) return { valid: true };

    const requiresPlus4 = zipCodeRequiresPlus4(zipCode.substring(0,5), year);
    if ((zipCode.length != 5 && zipCode.length != 9) || isNaN(Number(zipCode)))
        return {
            valid: false,
            message: "Zip code must be either 5 or 9 numbers.",
            level: 'error'
        };
    else if (requiresPlus4 && zipCode.length < 9)
        return { 
            valid: false,
            message: messageText, 
            level: 'warning' 
        };

    return { valid: true }
}


export {
    validateLineServiceDate,
    validateBilled,
    validateZipCode
};